import { AuthScreen } from '~/auth-flow/screens/base-auth-screen';
import { PasscodeAuthScreen } from '~/auth-flow/screens/passcode-auth-screen';
import { TwoFactorAuthScreen } from '~/auth-flow/screens/2fa-auth-screen';
import { IntentAuthScreen } from '~/auth-flow/screens/intent-auth-screen';
import { ProfileAuthScreen } from '~/auth-flow/screens/profile-auth-screen';
import { SignupAuthScreen } from '~/auth-flow/screens/signup-auth-screen';
import { DrbDialog } from '~/web-components/drb-dialog/drb-dialog-helpers';

// Allow screens to register unique logic for themselves (extending the base class)
const screenClassLookup = {
  'auth-signup': SignupAuthScreen,
  'auth-signin': SignupAuthScreen, // Using same class for both signup and signin screens as they are the same
  'auth-intent': IntentAuthScreen,
  'auth-passcode': PasscodeAuthScreen,
  'auth-profile': ProfileAuthScreen,
  'auth-2fa': TwoFactorAuthScreen,
};

export const AuthFlow = {
  init() {
    if (window.Dribbble?.JsConfig?.user?.isLoggedIn) return;

    // Init initial screens when auth standalone page is loaded
    const initialScreens = document.querySelectorAll('[data-auth-page-container] [data-screen]');
    initialScreens.forEach((screen) => this.initScreen(screen));

    this.bindListeners();
  },

  bindListeners() {
    // Init initial screens when auth flow dialog is opened
    document.addEventListener('drb-dialog-content-updated', (e) => {
      const authDialog = e.target.closest('drb-dialog#auth-flow');
      if (!authDialog) return;

      const screens = authDialog.querySelectorAll('[data-screen]');
      screens.forEach((screen) => this.initScreen(screen));
    });

    // Trigger auth flow dialog when trying to perform certain actions
    document.addEventListener('click', (e) => {
      const authTrigger = e.target.closest('[data-signup-trigger]');
      const intent = authTrigger?.getAttribute('data-context');
      if (!authTrigger || authTrigger?.getAttribute('data-signup-trigger') === 'false') return;

      e.preventDefault();

      this.openAuthDialog({
        intent,
      });
    });

    document.addEventListener('auth-screen-injected', (e) => {
      this.initScreen(e.target);
    });
  },

  openAuthDialog({ intent, redirectUrl }) {
    const url = new URL('/signups/new', window.location.origin);
    url.searchParams.set('intent', intent);
    url.searchParams.set('redirect_url', redirectUrl || window.location.href);

    DrbDialog.openRemote({
      url,
      dialogId: 'auth-flow',
      nonModalMode: true, // Open in non-modal mode to allow recaptcha challenge to be displayed on top of dialog
    });
  },

  initScreen(screen) {
    const screenId = screen?.getAttribute('data-screen');
    if (!screenId || screen.screenInstance) return;

    const ScreenClass = screenClassLookup[screenId] || AuthScreen;
    screen.screenInstance = new ScreenClass(screen);
  },
};
